export default {
  loading: false,
  proposals: [],
  proposal: {},
  totalCount: 0,
  proposalCategory:[],
  proposalType:[]
};
